import { useState } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { HeaderDropDownContainer } from 'components/Header/partials';
import TryEasyOptionsButton from 'components/markets/partials/TryEasyOptionsButton';
import GreeksDropdown from 'components/options_chain/greeksDropdown';
import TrackerIntroSlides from 'components/TrackerIntroSlides';
import { IS_INDIAN_EXCHANGE } from 'constants/constants';
import { isEmpty, isNil, equals } from 'helpers/ramda';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import { ContractType } from 'types/IProducts';
import InfoPillButton from 'UIKit/InfoPillButton';

import Desktop24hrHeader from './desktop24hrHeader';
import HaltedLabel from './HaltedLabel';
import styles from './index.module.scss';
// import TradeLayoutHeader from 'components/tradeLayoutHeader';
import SelectedProducLastPrice from './lastPrice';
import ProductDetails from './productDetails';

const ProductHeader = () => {
  const [open, setOpen] = useState(false);
  const selectedProduct = useSelector(state => selectedProductSelector(state));
  const isOperational =
    selectedProduct && equals(selectedProduct?.trading_status, 'operational');
  const cancelMode =
    selectedProduct && equals(selectedProduct?.trading_status, 'disrupted_cancel_only');

  const showGreeks =
    selectedProduct?.contract_type === ContractType.OptionsCombos ||
    selectedProduct?.contract_type === ContractType.MoveOptions;

  const handleTrackerIntroSlides = () => {
    setOpen(true);
  };

  const handleTrackerIntroSlidesClose = () => {
    setOpen(false);
  };

  return (
    //  <TvReadyWrapper>
    //  {isTradingViewReady => isTradingViewReady ? (
    // ) : null}
    // </TvReadyWrapper>
    (<div
      className={cn(styles['product-header'], {
        [styles['auction-mode']]: !isOperational && !cancelMode,
        [styles['cancel-mode']]: !isOperational && cancelMode,
      })}
      data-palette="ProductHeader">
      <div id="header-dropdown" className={styles['header-dropdown']}>
        {!isNil(selectedProduct) && !isEmpty(selectedProduct) && (
          <HeaderDropDownContainer />
        )}
      </div>
      {!isNil(selectedProduct) && !isEmpty(selectedProduct) && (
        <SelectedProducLastPrice contractType={selectedProduct?.contract_type} />
      )}
      {isOperational ? (
        <>
          <div className={styles.divider} data-palette="ProductHeader" />
          <div
            id="header-placeholder"
            className={styles['ticker-header']}
            data-palette="ProductHeader">
            {!isNil(selectedProduct) && !isEmpty(selectedProduct) && (
              <Desktop24hrHeader selectedProduct={selectedProduct} />
            )}
          </div>
        </>
      ) : (
        !isNil(selectedProduct) &&
        !isEmpty(selectedProduct) && <HaltedLabel selectedProduct={selectedProduct} />
      )}
      {!isNil(selectedProduct) && !isEmpty(selectedProduct) && showGreeks && (
        <GreeksDropdown
          product={selectedProduct}
          classNames={{
            dropdownContainer: styles.dropdownContainer,
            // itemContainer: styles.itemContainer,
            // itemLabel: styles.itemLabel,
            // itemValue: styles.itemValue,
            button: styles.greeksButton,
          }}
        />
      )}
      {selectedProduct?.contract_type === ContractType.Tracker && (
        <InfoPillButton
          data-testid="hBooY-Yz48A4he-Fqgzg0"
          className={`${styles['tracker-button']} ml-auto`}
          onClick={handleTrackerIntroSlides}
        >
          What are Trackers
        </InfoPillButton>
      )}
      <div
        id="contract-details-placeholder"
        className={`${styles['contract-details']} ${
          !isOperational && !cancelMode && styles['auction-strip-class']
        } ${!isOperational && cancelMode && styles['cancel-mode-class']} ${
          selectedProduct?.contract_type === ContractType.Tracker &&
          styles['tracker-margin']
        }`}
      >
        {!isNil(selectedProduct) &&
          !isEmpty(selectedProduct) &&
          selectedProduct.contract_type !== 'spot' && (
            <ProductDetails selectedProduct={selectedProduct} />
          )}
      </div>
      {!IS_INDIAN_EXCHANGE && (
        <div
          className={cn(styles.tryEasyOptionsButton, {
            [styles.auctionStrip]: !isOperational,
            [styles.cancelStrip]: !isOperational && cancelMode,
          })}
          data-palette="ProductHeader">
          <TryEasyOptionsButton mixpanelSource="Futures" />
        </div>
      )}
      {/* <div id="header-placeholder" className={styles['trade-layout']}>
        <TradeLayoutHeader />
      </div> */}
      <TrackerIntroSlides open={open} onClose={handleTrackerIntroSlidesClose} />
    </div>)
  );
};

export default ProductHeader;
